module.exports = "https://static.wagwalking.com/_next/static/images/banner-photo-mobile_2x-d80eb59bc44fe00d1ea2ce7b5fc70faf.png";